// Lorem Ipsum Generator Tool — placeholder text by words, sentences or paragraphs.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const loremIpsumTool: Tool = {
  id: "lorem-ipsum",
  name: () => m.li_tool_name(),
  description: () => m.li_tool_description(),
  icon: "📝",
  basePath: "/lorem-ipsum",
  status: "stable",
  tags: ["lorem", "placeholder", "text", "design"],
  pages: [
    {
      name: () => m.li_nav_main(),
      path: "/lorem-ipsum",
      description: () => m.li_nav_main_desc(),
      icon: "📝",
    },
  ],
};
